import React, { useEffect, useState } from "react";
import AuctionList from "../inc/AuctionList";
import Footer from "../inc/Footer";
import axios from "axios";
import "../inc/GlobalVars";
import Loader from "../inc/Loader";

function Auctions() {
  const[loading,setLoading] = useState(false);
  const [auctionListItems, setAuctionListItems] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [checkedVehicleTypes, setCheckedVehicleTypes] = useState([]);
  const [checkedStates, setCheckedStates] = useState([]);
  const [checkedOwnership, setCheckedOwnership] = useState([]);
  const [checkedRc, setCheckedRc] = useState([]);
  const [checkedFuel, setCheckedFuel] = useState([]);
  const user_id = localStorage.getItem('userId');
  useEffect(() => {
    //getAuctionList(); // Fetch auction list immediately when component mounts
    const intervalId = setInterval(() => {
        if (!(checkedVehicleTypes.length || checkedStates.length || checkedOwnership.length || checkedRc.length || checkedFuel.length)) {
         
            getAuctionList(); // Refresh auction list every 5 seconds only if no filters are applied
        }
    }, 3000);

    return () => {
        clearInterval(intervalId); // Clear the interval when component unmounts
    };
}, [checkedVehicleTypes, checkedStates, checkedOwnership, checkedRc, checkedFuel]);
  async function getAuctionList() {

    //setLoading(true);
    try {
      const [auctionData, statesData, fuelTypeData, vehicleTypeData] = await Promise.all([
        axios.post(global.apiUrl + "/getAuctionList/"+user_id),
        axios.get(global.apiUrl + "/getBuyerStates/"+user_id),
        axios.get(global.apiUrl + "/getAllFuelTypes"),
        axios.get(global.apiUrl + "/getAllVehicleTypes"),
      ]);
  
      setAuctionListItems(auctionData.data["data"]);
      setAllStates(statesData.data["data"]);
      setFuelTypes(fuelTypeData.data["data"]);
      setVehicleTypes(vehicleTypeData.data["data"]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Set loading state to false after requests are completed
    }
  }


  const handleVehicleCheckBox = (e) => {
    const value = e.target.value;
    setCheckedVehicleTypes((prevVehicleValues) => {const updatedValues = e.target.checked ? [...prevVehicleValues, value] : prevVehicleValues.filter((item) => item !== value);
    filterAuctionList(updatedValues,checkedStates,checkedOwnership,checkedRc,checkedFuel); return updatedValues;})
  }

  const handleStateCheckBox = (e) => {
    const value = e.target.value;
    setCheckedStates((prevVehicleValues) => {const updatedValues = e.target.checked ? [...prevVehicleValues, value] : prevVehicleValues.filter((item) => item !== value);
    filterAuctionList(checkedVehicleTypes,updatedValues,checkedOwnership,checkedRc,checkedFuel); return updatedValues;})
  }

  const handleOwnershipCheckBox = (e) => {
    const value = e.target.value;
    setCheckedOwnership((prevVehicleValues) => {const updatedValues = e.target.checked ? [...prevVehicleValues, value] : prevVehicleValues.filter((item) => item !== value);
    filterAuctionList(checkedVehicleTypes,checkedStates,updatedValues,checkedRc,checkedFuel); return updatedValues;})
  }

  const handleRcCheckBox = (e) => {
    const value = e.target.value;
    setCheckedRc((prevVehicleValues) => {const updatedValues = e.target.checked ? [...prevVehicleValues, value] : prevVehicleValues.filter((item) => item !== value);
    filterAuctionList(checkedVehicleTypes,checkedStates,checkedOwnership,updatedValues,checkedFuel); return updatedValues;})
  }

  const handleFuelCheckBox = (e) => {
    const value = e.target.value;
    setCheckedFuel((prevVehicleValues) => {const updatedValues = e.target.checked ? [...prevVehicleValues, value] : prevVehicleValues.filter((item) => item !== value);
    filterAuctionList(checkedVehicleTypes,checkedStates,checkedOwnership,checkedRc,updatedValues); return updatedValues;})
  }

async function filterAuctionList(updatedVehicleTypes,updatedStateValues,updatedOwnershipValues,updatedRcValues,updatedFuelValues) {
  setAuctionListItems([]);
  const vehicleTypeData = updatedVehicleTypes.join(',');
  const stateData = updatedStateValues.join(',');
  const ownerData = updatedOwnershipValues.join(',');
  const rcData = updatedRcValues.join(',');
  const fuelData = updatedFuelValues.join(',');
 

 console.log("state"+stateData);
  try{
    const [auctionData2] = await Promise.all([
      axios.post(global.apiUrl + '/getFilterAuctionList',JSON.stringify({vehicleTypes:vehicleTypeData,state_ids:stateData,ownership:ownerData,rc:rcData,fuel:fuelData,user_id:user_id}))
    ]);

    //setAuctionListItems(auctionData2.data["data"]);
    //console.log(auctionData2.data["data"]);
    setAuctionListItems(auctionData2.data["data"]);
   
  } catch(error)
  {
    console.log(error);
  }finally
  {
    
  }
}

  
  return (
    <div>
 {loading ? ( <Loader /> ) : (
<>
      
      <div className="container  mb-5 ps-4 pe-3">
        <div className="row">
          
          <div className="col-md-3 pt-3 ps-0 pe-0" style={{background:"#fff"}}>
            <h3 className=" sidebar-heading">Vehicle</h3>
            <ul className="list-style-none">
            {vehicleTypes.map((vt, key) => (
                <li key={key}>
                  <input type="checkbox" className="vehicle_type" value={vt.id} onChange={handleVehicleCheckBox} />{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {vt.vehicle_type}
                  </span>
                </li>
              ))}
            </ul>

            <h3 className="mt-3 sidebar-heading">States</h3>
            <ul className="list-style-none">
              {allStates.map((st, key) => (
                <li key={key}>
                  <input type="checkbox" className="state_id" value={st.id} onChange={handleStateCheckBox} />{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {st.state}
                  </span>
                </li>
              ))}
            </ul>

            <h3 className="mt-3 sidebar-heading">Ownership</h3>
            <ul className="list-style-none">
              <li>
                <input value="1" className="ownerships" onChange={handleOwnershipCheckBox} type="checkbox" /> 1
              </li>
              <li>
                <input value="2" className="ownerships" onChange={handleOwnershipCheckBox} type="checkbox" /> 2
              </li>
              <li>
                <input value="3" className="ownerships" onChange={handleOwnershipCheckBox} type="checkbox" /> 3
              </li>
              <li>
                <input value="4" className="ownerships" onChange={handleOwnershipCheckBox} type="checkbox" /> 3+
              </li>
            </ul>
            <h3 className="mt-3 sidebar-heading">RC Available</h3>
            <ul className="list-style-none">
              <li>
                <input value="1"  className="rc_available" onChange={handleRcCheckBox} type="checkbox" /> Yes
              </li>
              <li>
                <input value="0" className="rc_available" onChange={handleRcCheckBox} type="checkbox" /> No
              </li>
            </ul>
            <h3 className="mt-3 sidebar-heading">Fuel Type</h3>
            <ul className="list-style-none">
            {fuelTypes.map((ft, key) => (
                <li key={key}>
                  <input type="checkbox" className="fuel_type" value={ft.id} onChange={handleFuelCheckBox} />{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {ft.fuel_type}
                  </span>
                </li>
              ))}
            </ul>
            
          </div>
          

          
           <div className="col-md-9">

           <div className="row">
           {auctionListItems.map((ac, key) => (
              <AuctionList
                key={key}
                reg_number={ac.reg_number}
                case_name={ac.case_name}
                location={ac.location}
                rc_availability={ac.rc_availability}
                make_name={ac.make_name}
                model={ac.model}
                variant = {ac.variant}
                year={ac.manufacture_year}
                expiry_date={ac.expiry_date}
                expiry_time={ac.expiry_time}
                featured_image={ac.featured_image}
                min_bid={ac.min_price}
                vehicle_id={ac.vehicle_id}
                watchlist ={ac.watchlist_data}
                owners = {ac.ownership}
                transmission = {ac.transmission}
                cname = {ac.name}
                cmobile = {ac.mobile}
                bid_max_amount = {ac.bid_amount_max}
                bid_win_status = {ac.bid_win_status}
                can_bid = {ac.can_bid}
                state = {ac.state}
              />
            ))}
           </div>
           </div>
          </div>
        </div>
    
      <Footer />
      </> )}</div> );
  
}

export default Auctions;
